'use strict';

import {ListCtrl} from '../esfasi/listctrl.js';

import {indicatorModel} from "../../models/indicatormodel.js";

export class IndicatorsListCtrl extends ListCtrl
{
	storageNames = {
		query: 'IndicatorsListCtrlQuery'
	};
	type = '';
	$mdDialog;
	removeUrl;
	canRemove = false;
	
	
	constructor($scope, $http, $filter, $timeout, $locale, jsDataService, $mdDialog){
		super($scope, $http, $filter, $timeout, $locale, jsDataService);
		this.cfgExportUrl = this.jsDataService.get('cfgExportUrl', '');
		this.cfgAddUrl = this.jsDataService.get('cfgAddUrl');
		this.type = this.jsDataService.get('cfgType', '');
		this.$mdDialog = $mdDialog;
		this.storageNames.query = 'Indicators'+this.type+'ListCtrlQuery';
		if(this.type === 'manual'){
			this.removeUrl = this.jsDataService.get('cfgRemoveUrl', '');
			this.canRemove = (this.removeUrl !== '');
		}
	}
	
	setData(data){
		this.data = [];
		for(let ln of data){
			this.data.push(new indicatorModel(ln, this.$filter, this.jsDataService));
		}
	}
	
	getColValue(row, col){
		if(typeof(row[col]) === 'undefined'){
			return '';
		}
		if(row instanceof indicatorModel){
			return row.getValue(col);
		}
		return row[col];
	}
	
	getFooterData(col){
		return '';
	}
	
	exportList(){
		const query = new URLSearchParams({
			filters: JSON.stringify(this.query.filters),
//			limit: this.query.limit,
//			page: this.query.page,
		});
		
		const ts = new Date().toISOString().substring(0, 19).replace(/-|:|T/g, '');
		
		const a = document.createElement('a');
		a.style.display = 'none';
		const link = `${this.cfgExportUrl}?${query.toString()}`;
		a.href = link;
		a.download = `Indicator_${this.type}_${ts}.xlsx`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
	
	addValue(ev){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "jsDataService", this.addValueDlg],
			templateUrl: 'indicators/ng_addvalue_dlg.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true
//				locals: {
//					evaluation: this.evaluation
//				}
		}).then((results) => {
			
			if (this.cfgAddUrl) {
				this.$scope.basicHttpConfigProcess({
					url: this.cfgAddUrl,
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){
						this.loadData();
					}
				}, () => {});
			}
		}, () => {
		});

	}
	
	addValueDlg($scope, $mdDialog, $filter, jsDataService) {
		
		$scope.indicatorValue = {
			date_cet: new Date(),
			invitation_id: 0,
			project_id: 0,
			indicator_id: 0,
			unit_id: 0,
			value: null
		};
		
		$scope.classif = jsDataService.get('cfgClassif', {});
		
		$scope.invitationChanged = function(){
			const project = getSelectedProject();
			if(project && project.invitation_id != $scope.indicatorValue.invitation_id){
				$scope.indicatorValue.project_id = 0;
			}
		};
		
		$scope.projectChanged = function(){
			const project = getSelectedProject();
			if(project && project.invitation_id != $scope.indicatorValue.invitation_id){
				$scope.indicatorValue.invitation_id = project.invitation_id;
			}
		};
		
		function getSelectedProject(){
			if($scope.indicatorValue.project_id > 0){
				let r = $filter('filter')($scope.classif.projects, {id: $scope.indicatorValue.project_id}, true);
				if(r.length > 0){
					return r[0];
				}
			}
			return null;
		}
		
		$scope.close = function () {
			$mdDialog.cancel();
		};

		$scope.submitDialog = function () {
			$scope.indicatorValue.date = $filter('date')($scope.indicatorValue.date_cet, 'yyyy-MM-dd');
			$mdDialog.hide($scope.indicatorValue);
		};
	}
	
	removeValue(ev, item){
		if(this.canRemove && item instanceof indicatorModel){
			const confirmTexts = this.jsDataService.get('removeValueConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.removeUrl,
					method: 'GET',
					responseType: 'json',
					params: {
						id: item.id
					}
				}).then((results) => {
					if(results.data.success){
						this.loadData();
					}
				});
			}, () => {});
		}
	}
}


